import { authRoles } from '@/core/constants'
import { RouteRecordRaw } from 'vue-router'

const { ADMIN } = authRoles

const Reports = () =>
  import(/* webpackChunkName: "reports-view" */ './pages/index.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/reports',
    name: 'reports',
    component: Reports,
    meta: {
      title: 'Reportes',
      auth: {
        roles: [ADMIN], // Roles permitidos
        redirect: '/auth/login', // Redirección si no está autenticado
        forbiddenRedirect: '/403', // Redirección si no tiene los roles necesarios
      },
    },
  },
]
